import React from "react";

const Navbar = () => {
  return (
    <div>
      <nav
        className="bg-dark d-flex align-items-center justify-content-center text-center"
        style={{ width: "100vw" }}
      >
        <div
          className="my-2"
          style={{ color: "#fff", fontSize: "2rem", fontWeight: "bold" }}
        >
          Online examination System
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
